import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { useResourceCenterArticle } from 'app/templates/ResourceCenterArticle/useResourceCenterArticle';
import AssetWrapper from 'atoms/Asset/AssetWrapper';
import Typography from 'atoms/Typography/Typography';

const HeroBanner = (): JSX.Element => {
  const { heroBanner } = useResourceCenterArticle();

  const renderLabelAndValue = (label: string, value: string) => {
    return (
      <Stack
        direction='column'
        gap='spacing-lg'
      >
        <Typography
          type='paragraph'
          size='sm'
          color='text-brand-tertiary'
          fontWeight='font-weight-semibold'
        >
          {label}
        </Typography>
        <Typography
          type='paragraph'
          size='md'
          color='text-tertiary'
        >
          {value}
        </Typography>
      </Stack>
    );
  };

  return (
    <Grid
      gap='spacing-4xl'
      gapSm='spacing-2xl'
    >
      <Stack
        direction='column'
        columns={8}
        columnsXl={9}
        columnsLg={11}
        columnsMd={12}
      >
        <HeadingAndSupportingText
          heading={{
            type: 'heading',
            size: 'lg',
            text: heroBanner.title,
          }}
          supportingText={{
            type: 'paragraph',
            size: 'xl',
            text: heroBanner.description,
            color: 'text-tertiary',
          }}
          subHeadingGap='spacing-xl'
          subHeading={{
            type: 'paragraph',
            size: 'md',
            text: heroBanner.category,
            color: 'text-brand-secondary',
            fontWeight: 'font-weight-semibold',
          }}
        />
      </Stack>
      <Stack
        columns={12}
        direction='row'
        gap='spacing-6xl'
        padding={['spacing-4xl', 'spacing-none', 'spacing-none', 'spacing-none']}
      >
        {renderLabelAndValue('Author', heroBanner.author)}
        {renderLabelAndValue('Last Updated', heroBanner.updatedAt)}
      </Stack>
      <Stack
        columns={12}
        justify='center'
        align='center'
        gap='spacing-4xl'
        gapSm='spacing-2xl'
      >
        <AssetWrapper
          imageProps={{ image: heroBanner.image.gatsbyImageData, alt: heroBanner.title }}
          radius='radius-2xl'
          cover
        />
      </Stack>
    </Grid>
  );
};

export default HeroBanner;
